<template>
  <div class="mt-2">
    <div v-if="product">
      <v-layout>
        <v-flex>
          <v-btn flat @click="cancelContent">
            <em class="fas fa-chevron-left mr-1" />
            {{ $t('Back') }}
          </v-btn>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn depressed color="primary" @click="saveProduct">{{ $t('Save') }}</v-btn>
        </v-flex>
      </v-layout>

      <h3 class="headline mt-3">{{ $t('Edit Product') }}</h3>

      <!-- <div class="form-control mt-3" :class="{ 'has-error': errors.has('categoryInput') }">
        <label class="caption" for="categoryInput">{{ $t('Category') }} *</label>
        <select-category
          :pageid="pageid"
          v-model="category"
          :selected="currentCategory"
          @onChangeCategory="onChangeCategory"
          data-vv-name="categoryInput"
          :data-vv-as="$t('Category')"
          v-validate="'required'"
        ></select-category>
        <p class="text-error" v-show="errors.has('categoryInput')">
          {{ errors.first('categoryInput') }}
        </p>
      </div> -->

      <div class="pb-3 form-control" :class="{ 'has-error': errors.has('uploadMultipleFile') }">
        <upload-multiple-file
          v-model="productImages"
          :max="10"
          data-vv-name="uploadMultipleFile"
          data-vv-as="Preview Image"
        ></upload-multiple-file>

        <span class="text-error" v-show="errors.has('uploadMultipleFile')">{{
          errors.first('uploadMultipleFile')
        }}</span>
      </div>
      <v-layout v-if="selectedBot.theme == 'runkan'" row wrap>
        <v-flex xs6 class="pr-2">
          <div>ภาพพื้นหลังผลวิ่ง</div>
          <div class="pb-3 form-control" :class="{ 'has-error': errors.has('uploadMultipleFile') }">
            <uploadfile
              v-model="product.photohash"
              :max="10"
              data-vv-name="อัพโหลดผลวิ่ง"
              data-vv-as="อัพโหลดผลวิ่ง"
            ></uploadfile>

            <span class="text-error" v-show="errors.has('uploadMultipleFile')">
              {{ errors.first('uploadMultipleFile') }}
            </span>
          </div>
        </v-flex>
        <v-flex xs6>
          <div>ภาพพื้นหลัง E-Certificate</div>
          <div class="pb-3 form-control" :class="{ 'has-error': errors.has('uploadMultipleFile') }">
            <uploadfile
              v-model="product.source"
              :max="10"
              data-vv-name="อัพโหลดผลวิ่ง"
              data-vv-as="อัพโหลดผลวิ่ง"
            ></uploadfile>

            <span class="text-error" v-show="errors.has('uploadMultipleFile')">
              {{ errors.first('uploadMultipleFile') }}
            </span>
          </div></v-flex
        >
      </v-layout>
      <div class="form-control" :class="{ 'has-error': errors.has('nameInput') }">
        <label class="caption" for="nameInput">{{ $t('Product Name') }} *</label>
        <input
          type="text"
          class="form-control"
          ref="name"
          id="nameInput"
          name="nameInput"
          :data-vv-as="$t('Product Name')"
          aria-describedby="name"
          :placeholder="$t('Product Name')"
          v-model="product.name"
          v-validate="'required'"
          @blur="$set(product, 'name', noSpaceAndSpecial($event))"
        />
        <span class="text-error" v-show="errors.has('nameInput')">{{
          errors.first('nameInput')
        }}</span>
      </div>

      <!-- <template v-if="selectedBot.pageid != '114660513608160'">
        <div class="form-control" :class="{ 'has-error': errors.has('codeInput') }">
          <label v-if="selectedBot.theme == 'runkan'" class="caption" for="codeInput">{{
            $t('ชื่อย่อโครงการ')
          }}</label>
          <label v-else class="caption" for="codeInput">{{ $t('SKU') }}</label>
          <input
            type="text"
            class="form-control"
            id="codeInput"
            name="codeInput"
            :data-vv-as="$t('SKU')"
            aria-describedby="SKU"
            :placeholder="$t('SKU')"
            v-model="product.code"
          />
          <span class="text-error" v-show="errors.has('codeInput')">{{
            errors.first('codeInput')
          }}</span>
        </div>
      </template> -->

      <div class="form-control" :class="{ 'has-error': errors.has('priceInput') }">
        <label class="caption" for="priceInput">{{ $t('Price') }} *</label>
        <div class="form-inline">
          <div
            style="
              padding: 6px 12px;
              border-radius: 50%;
              display: inline-block;
              background: #eee;
              margin-right: 5px;
            "
          >
            {{ currencySign }}
          </div>
          <input
            type="text"
            class="form-control"
            id="priceInput"
            name="priceInput"
            :data-vv-as="$t('Price')"
            ref="price"
            aria-describedby="price"
            :placeholder="$t('Price')"
            v-model="product.price"
            v-validate="'required|decimal|min_value:0'"
            style="max-width: 150px; display: inline"
            @blur="
              $set(product, 'price', decimalOnly($event))
              onChangePrice()
            "
          />
          &nbsp;
          <span class="text-error" v-show="errors.has('priceInput')">{{
            errors.first('priceInput')
          }}</span>
        </div>
      </div>

      <!-- <div class="form-control" :class="{ 'has-error': errors.has('discountPriceInput') }">
        <label class="caption" for="dicountPriceInput">{{ $t('Sale price') }} *</label>
        <div class="form-inline">
          <div
            style="
              padding: 6px 12px;
              border-radius: 50%;
              display: inline-block;
              background: #eee;
              margin-right: 5px;
            "
          >
            {{ currencySign }}
          </div>
          <input
            type="text"
            class="form-control"
            id="discountPriceInput"
            name="discountPriceInput"
            :data-vv-as="$t('Sale price')"
            aria-describedby="Sale Price"
            :placeholder="$t('Sale price')"
            v-model="product.discountprice"
            v-validate="'decimal|min_value:0|isLessThanOrEqual:price'"
            style="max-width: 150px; display: inline"
            @blur="$set(product, 'discountprice', decimalOnly($event))"
          />
          <div
            class="text-xs-center"
            v-if="
              product.discountprice &&
                parseFloat(product.discountprice) > 0 &&
                parseFloat(product.price) > parseFloat(product.discountprice)
            "
            style="padding: 5px 10px; background: red; color: white; display: inline-block"
          >
            {{ (((product.price - product.discountprice) / product.price) * 100) | numberFormat }}%
          </div>
          <div
            class="text-xs-center"
            v-else
            style="padding: 5px 10px; background: #eee; color: white; display: inline-block"
          >
            0%
          </div>
          <div>
            <span class="text-error" v-show="errors.has('discountPriceInput')">{{
              errors.first('discountPriceInput')
            }}</span>
          </div>
        </div>
      </div> -->

      <!-- <div class="form-control" v-if="selectedBot.theme == 'foodguru'">
        <div style="margin-top: 20px;">
          <label style="font-size: 16px;">ประเภทสินค้า</label>
        </div>
        <v-radio-group v-model="product.producttype" row>
          <v-radio label="ของสด" :value="'ของสด'" color="primary"></v-radio>
          <v-radio label="ของแห้ง" :value="'ของแห้ง'" color="primary"></v-radio>
        </v-radio-group>
      </div> -->

      <!-- <template v-if="selectedBot.pageid != '114660513608160'">
        <div class="form-control" :class="{ 'has-error': errors.has('productWeightInput') }">
          <label class="caption" for="productWeightInput"
            >{{ $t('Product Weight') }} ({{ $t('gram') }})</label
          >
          <div>
            <input
              type="text"
              class="form-control"
              id="productWeightInput"
              name="productWeightInput"
              :data-vv-as="$t('Product Weight')"
              aria-describedby="productWeight"
              ref="productWeight"
              :placeholder="$t('Product Weight')"
              v-model="product.weight"
              v-validate="'decimal:2|min_value:0'"
            />
            <span class="text-error" v-show="errors.has('productWeightInput')">{{
              errors.first('productWeightInput')
            }}</span>
          </div>
        </div>
      </template> -->

      <div class="form-control" :class="{ 'has-error': errors.has('descriptionInput') }">
        <div>
          <label class="caption" for="nameInput">{{ $t('Product detail') }} *</label>
        </div>
        <textarea
          type="text"
          class="form-control"
          id="descriptionInput"
          style="resize: vertical; min-height: 90px; width: 100%"
          name="descriptionInput"
          :data-vv-as="$t('Product detail')"
          aria-describedby="description"
          :placeholder="$t('Product detail')"
          row="3"
          v-model="product.description"
          v-validate="'required'"
        ></textarea>
        <span class="text-error" v-show="errors.has('descriptionInput')">{{
          errors.first('descriptionInput')
        }}</span>
      </div>

      <template v-if="!loadingProductStock">
        <ScgdisProductStock
          v-if="selectedBot.theme == 'scgdistribution'"
          v-model="productstock"
          :category="productstockcategories"
          :product="product"
          @close="close()"
          @updateCategory="updateCategory"
          @deleteStock="deleteStock"
        ></ScgdisProductStock>
        <product-stock
          v-else
          v-model="productstock"
          :category="productstockcategories"
          :product="product"
          @updateCategory="updateCategory"
          @deleteStock="deleteStock"
        ></product-stock>
      </template>
      <template
        v-if="selectedBot.pageid != '114660513608160' && !['runkan'].includes(selectedBot.theme)"
      >
        <template v-if="!isLoadingBundle && $store.getters.getPackage == 'premium'">
          <h3 class="headline">{{ $t('Wholesale') }}</h3>
          <product-bundle
            v-model="productbundle"
            @deleteBundle="deleteBundle"
            :price="product.price ? parseFloat(product.price) : 0"
          ></product-bundle>
        </template>
      </template>

      <template v-if="['runkan'].includes(selectedBot.theme)">
        <runkan-datetime :product="product" :type="'edit'" v-model="runkandate"></runkan-datetime>
      </template>

      <template v-if="$store.state.specialpage.includes(selectedBot.pageid)">
        <div class="hr" style="margin-top: 35px"></div>
        <template v-if="$store.getters.getPackage == 'premium'">
          <div class="text-xs-center" style="margin-top: -15px">
            <a
              class="btn-advanced"
              href="javascript:void(0);"
              @click="showAdvanced = !showAdvanced"
            >
              {{ $t('Advanced') }}
              <i
                class="fa"
                :class="{ 'fa-angle-down': showAdvanced, 'fa-angle-up': !showAdvanced }"
              />
            </a>
          </div>

          <template v-if="showAdvanced">
            <div class="row form-control" :class="{ 'has-error': errorTag.length > 0 }">
              <div class="col s12">
                <label class="caption" for="keywordInput">{{ $t('Keywords') }}</label>
                <tags
                  v-model="tag"
                  :tags="tags"
                  @tags-changed="(newTags) => (tags = newTags)"
                  @before-adding-tag="checkTag"
                />
                <span class="text-error" v-if="errorTag.length > 0">
                  <template v-if="errorTag.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col s12 m6">
                <div
                  class="form-control"
                  v-if="product.buttonaction == 'url' || product.buttonaction == 'buy'"
                >
                  <label class="caption" for="buttonNameInput">{{ $t('Button Name') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="buttonNameInput"
                    aria-describedby="Button Name"
                    :placeholder="$t('Button Name')"
                    v-model="product.buttonname"
                  />
                </div>
              </div>
              <div class="col s12 m6">
                <div class="form-control" v-if="product.buttonaction == 'url'">
                  <label class="caption" for="buttonUrlInput">{{ $t('Product Url') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="buttonUrlInput"
                    aria-describedby="Product Url"
                    :placeholder="$t('Product Url')"
                    v-model="product.buttonurl"
                  />
                </div>
              </div>
            </div>
          </template>
        </template>
      </template>

      <div class="text-xs-center">
        <v-btn color="grey" outline @click="cancelContent()">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed @click="saveProduct">{{ $t('Save') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import SelectCategory from './SelectCategory'
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import VueTagsInput from '@johmun/vue-tags-input'
import UploadMultipleFile from '@/components/elements/UploadMultipleFile'
import ProductStock from './ProductStock'
import ScgdisProductStock from './ScgdisProductStock'
import ProductBundle from './ProductBundle'
import Tags from '@/components/elements/Tags'
import { mapGetters } from 'vuex'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
import RunkanDatetime from './RunkanDatetime.vue'

export default {
  props: ['value', 'category'],
  inject: ['$validator'],
  data: function () {
    return {
      productImages: [],
      product: null,
      currentCategory: this.value.categoryid,
      categories: null,
      tag: '',
      currentView: 'product',
      showAdvanced: false,
      deleteStockList: [],
      deleteBundleList: [],
      productstock: [],
      productbundle: [],

      loadingStock: null,
      loadingBundle: null,
      stock_process_count: 0,
      bundle_process_count: 0,
      productstockcategories: [],

      isLoadingBundle: true,

      errorTag: [],
      loadingProductStock: true,
      oldStock: [],
      runkandate: {}
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    currencySign: function () {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case 'THB':
            return '฿'
          case 'MMK':
            return 'K'

          default:
            return '$'
        }
      }
      return '$'
    },
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    },
    tags: {
      get() {
        let vm = this
        if (vm.product.keyword != '') {
          var tags = vm.product.keyword.split(',')
          var result = []
          $.each(tags, function (index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function (index, val) {
          result.push(val.text)
        })
        vm.product.keyword = result.join(',')
      }
    }
  },
  components: {
    SelectCategory,
    uploadfile: uploadfile,
    VueTagsInput,
    UploadMultipleFile,
    ProductStock,
    ProductBundle,
    Tags,
    RunkanDatetime,
    ScgdisProductStock
  },
  mounted: async function () {
    let vm = this
    await this.$nextTick()
    goTo(0)
    vm.product = JSON.parse(JSON.stringify(vm.value))
    vm.product.buttonaction = 'url'
    vm.cached_product = JSON.stringify(vm.product)
    vm.productImages = vm.product.photourl ? vm.product.photourl.split(';;') : ''
    vm.loadingProductStock = true
    vm.productstock = []
    var productstock = vm.value.productstock.map((el) => {
      return [...el]
    })
    this.oldStock = vm.value.productstock.map((el) => {
      return el[0]
    })
    vm.productstock = productstock
    await vm.$nextTick()
    vm.loadingProductStock = false

    // try {
    //   vm.productstockcategories = JSON.parse(vm.product.productstockcategories)
    // } catch (error) {}
    // vm.cached_productstock = JSON.stringify(vm.value.productstock)

    if (vm.productImages.length > 0) {
      vm.productImages.map(function (val, index) {
        if (val == '') {
          vm.productImages.splice(index, 1)
        }
      })
    }
    vm.currentCategory = vm.product.categoryid
    // vm.$refs.name.focus();

    vm.isLoadingBundle = true
    vm.getProductBundle(function (data) {
      vm.productbundle = data
      vm.isLoadingBundle = false
    })

    document.addEventListener('keydown', (e) => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })

    // if (vm.selectedBot.theme == 'foodguru') {
    //   if(!this.product.producttype) {
    //     this.product.producttype = "ของสด"
    //   }
    // }
  },
  methods: {
    updateCategory(category) {
      this.productstockcategories = category
    },
    getProductBundle: function (callback) {
      let vm = this
      var data = {
        id: vm.product.id
      }

      api.getProductBundle(data, function (error, response) {
        if (error) {
          console.error(error)
          callback([])
          return
        }

        callback(response.productbundlelist)
      })
    },
    onChangeCategory: function (payload) {
      this.currentCategory = payload
    },
    saveProduct: async function () {
      let vm = this
      var result = await vm.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        vm.goToErrorInput()

        return false
      }
      let product = { ...vm.product }

      // product.productstock = []

      // var deleteStock = []

      if (this.$store.state.centralPage.includes(vm.selectedBot.pageid)) {
        var newProductStockId = []
        vm.productstock.map((el) => {
          if (el[0]) newProductStockId.push(el[0])
        })

        // vm.product.productstock.map(el => {
        //   if (el[0] && !newProductStockId.includes(el[0])) deleteStock.push(el[0])
        // })
        // console.log(vm.productstock, vm.product.productstock, newProductStockId, deleteStock)
      }
      // vm.productstock.map((val, index) => {
      //   product.productstock.push({ ...val })
      // })

      product.name = product.name.trim()
      product.price = parseFloat(product.price)
      // product.discountprice = product.discountprice
      //   ? parseFloat(product.discountprice)
      //   : product.price
      product.pageid = vm.pageid
      // product.weight = product.weight == null ? '' : product.weight
      // product.buttonname = product.buttonname == null ? '' : product.buttonname
      // product.buttonurl = product.buttonurl == null ? '' : product.buttonurl

      product.photourl = vm.productImages ? vm.productImages.join(';;') : ''
      product.categoryid = vm.currentCategory

      // product.productstockcategories = JSON.stringify(vm.productstockcategories)
      // Object.assign(product, this.runkandate)

      // if (vm.selectedBot.theme == 'foodguru') {
      //   Object.assign(product, { producttype: this.product.producttype })
      // }

      vm.$store.dispatch('loading')
      try {
        var response = await vm.editProduct(product)

        // await vm.saveStock(deleteStock)
        // if (vm.$store.getters.getPackage === 'premium') {
        //   await vm.saveBundle()
        // }
        vm.completeSaveProduct(product)
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    async editProduct(product) {
      return new Promise((resolve, reject) => {
        api.editProductKFC(
          {
            ...product
          },
          function (error, response) {
            if (error) reject(error)
            resolve(response)
          }
        )
      })
    },
    completeSaveProduct: function (product) {
      this.cached_product = JSON.stringify(product)
      this.cached_productstock = JSON.stringify(this.productstock)

      this.$emit('input', product)
      this.$emit('onSaveProduct')
    },
    saveStock: async function (deleteStock) {
      let vm = this

      let productstock = []

      vm.stock_process_count = vm.productstock.length + vm.deleteStockList.length

      var promiseUpdateProductStock = []

      vm.productstock.forEach(function (value, index) {
        let stock = {
          id: value[0],
          option: value[1],
          productid: vm.product.id,
          quantity: value[2],
          sku: value[5] ? value[5] : '',
          orders: index,
          photourl: value[7] ? value[7] : null
        }
        if (vm.selectedBot.theme == 'scgdistribution') {
          Object.assign(stock, { quantitylimit: value[8] ? value[8] : null })
        }
        if (value[3] == '' || parseFloat(value[3]) == 0) {
          stock.price = null
        } else {
          stock.price = value[3]
        }

        if (value[4] == '' || parseFloat(value[4]) == 0) {
          stock.discountprice = null
        } else {
          stock.discountprice = value[4]
        }

        if (value[0] == null) {
          promiseUpdateProductStock.push(
            vm.saveProductStock(stock).then((response) => {
              vm.productstock[index][0] = response.productstockid
            })
          )
        } else {
          promiseUpdateProductStock.push(vm.editProductStock(stock))
        }
      })

      // console.log(promiseUpdateProductStock)
      var updateProductStock = await Promise.all(promiseUpdateProductStock)

      var newStock = vm.productstock.map((el) => {
        return el[0]
      })
      var promiseDeleteProductStock = []
      var deleteList = this.oldStock.filter((el) => {
        return !newStock.includes(el)
      })
      if (deleteList.length > 0) {
        deleteList.forEach(function (val) {
          promiseDeleteProductStock.push(vm.deleteProductStock(val))
        })
        var deleteProductStock = await Promise.all(promiseDeleteProductStock)
      }
    },
    saveProductStock(stock) {
      return new Promise((resolve, reject) => {
        api.saveProductStock(stock, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    editProductStock(stock) {
      return new Promise((resolve, reject) => {
        api.editProductStock(stock, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    deleteProductStock(stock) {
      return new Promise((resolve, reject) => {
        api.deleteProductStock(stock, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    saveBundle: async function () {
      let vm = this

      let productbundle = []

      vm.bundle_process_count = vm.productbundle.length + vm.deleteBundleList.length

      var promiseBundle = []

      $.each(vm.productbundle, function (index, value) {
        let bundle = value
        bundle.productid = vm.product.id

        if (bundle.id == null) {
          promiseBundle.push(
            vm.saveProductBundle(bundle).then((response) => {
              vm.productbundle[index].id = response.productbundleid
            })
          )
        } else {
          promiseBundle.push(vm.editProductBundle(bundle))
        }
      })

      var updateBundle = await Promise.all(promiseBundle)

      var promiseDeleteBundle = []
      $.each(vm.deleteBundleList, function (index, val) {
        promiseDeleteBundle.push(vm.deleteProductBundle(val))
      })

      var deleteBundle = await Promise.all(promiseDeleteBundle)
    },
    saveProductBundle(bundle) {
      return new Promise((resolve, reject) => {
        api.saveProductBundle(bundle, function (error, response) {
          if (error) reject(error)
          resolve(response)
        })
      })
    },
    editProductBundle(bundle) {
      return new Promise((resolve, reject) => {
        api.editProductBundle(bundle, function (error, response) {
          if (error) reject(error)
          resolve(response)
        })
      })
    },
    deleteProductBundle(bundle) {
      return new Promise((resolve, reject) => {
        api.deleteProductBundle(bundle, function (error, response) {
          if (error) reject(error)
          resolve(response)
        })
      })
    },
    deleteStock: function (id) {
      this.deleteStockList.push(id)
    },
    deleteBundle: function (id) {
      this.deleteBundleList.push(id)
    },
    checkTag: function (obj) {
      this.errorTag = []
      if (this.tags.map((t) => t.text).indexOf(obj.tag.text) !== -1) {
        this.errorTag.push('duplicate')
      } else obj.addTag()
    },
    onDeleteProduct: function (id) {
      if (confirm('Do you want to delete this?')) {
        let vm = this
        vm.$store.dispatch('loading')
        api.deleteProduct(id, function (error, response) {
          if (error) {
            vm.$store.dispatch('loading')
            console.error(error)
            return
          }

          vm.$emit('productDeleted')
          vm.$emit('close')
          vm.$store.dispatch('loading')
        })
      }
    },
    cancelContent: function () {
      var vm = this
      vm.product = JSON.parse(vm.cached_product)
      // vm.productstock = JSON.parse(vm.cached_productstock)
      vm.productImages = vm.product.photourl ? vm.product.photourl.split(';;') : ''

      vm.$emit('close')
    },
    onChangePrice: function () {
      this.product.discountprice = this.product.price
    }
  },
  watch: {
    value: async function (newVal, oldVal) {
      let vm = this
      vm.product = JSON.parse(JSON.stringify(vm.value))
      vm.product.buttonaction = 'url'
      vm.cached_product = JSON.stringify(vm.product)

      vm.loadingProductStock = true
      vm.productstock = []
      var productstock = vm.value.productstock.map((el) => {
        return [...el]
      })
      this.oldStock = vm.value.productstock.map((el) => {
        return el[0]
      })
      vm.productstock = productstock
      await vm.$nextTick()
      vm.loadingProductStock = false
      vm.cached_productstock = JSON.stringify(vm.value.productstock)
      vm.currentCategory = vm.product.categoryid

      vm.productImages = vm.product.photourl ? vm.product.photourl.split(';;') : ''

      vm.isLoadingBundle = true
      vm.getProductBundle(function (data) {
        vm.productbundle = data
        vm.isLoadingBundle = false
      })
    }
  }
}
</script>

<style scroped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ModalEditProductKFC.vue